<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="crossorigin" />
  <link rel="preload" as="style"
    href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Nunito+Sans:wght@300;400;600;700&amp;display=swap" />
  <link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Nunito+Sans:wght@300;400;600;700&amp;display=swap"
    media="print" onload="this.media='all'" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="crossorigin" />
  <link rel="preload" as="style"
    href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Roboto:wght@300;400;500;700&amp;display=swap" />
  <link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Roboto:wght@300;400;500;700&amp;display=swap"
    media="print" onload="this.media='all'" />
  <noscript>
    <link rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Roboto:wght@300;400;500;700&amp;display=swap" />
    <link rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Nunito+Sans:wght@300;400;600;700&amp;display=swap" />
  </noscript>


  <link href="/assets/css/bootstrap.min.css?ver=1.1.0" rel="stylesheet">
  <link href="/assets/css/font-awesome/css/all.min.css?ver=1.1.0" rel="stylesheet">
  <link href="/assets/css/aos.css?ver=1.1.0" rel="stylesheet">
  <link href="/assets/css/main.css?ver=1.1.0" rel="stylesheet">

  <link href="/assets/2nd/css/font-awesome/css/all.min.css?ver=1.2.0" rel="stylesheet">
  <link href="/assets/2nd/css/bootstrap.min.css?ver=1.2.0" rel="stylesheet">
  <link href="/assets/2nd/css/aos.css?ver=1.2.0" rel="stylesheet">
  <link href="/assets/2nd/css/main.css?ver=1.2.0" rel="stylesheet">
  <link href="/assets/2nd/css/mine.css?ver=1.2.0" rel="stylesheet">

   <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="crossorigin" />
  <link rel="preload" as="style"
    href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Nunito+Sans:wght@300;400;600;700&amp;display=swap" />
  <link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Nunito+Sans:wght@300;400;600;700&amp;display=swap"
    media="print" onload="this.media='all'" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="crossorigin" />
  <link rel="preload" as="style"
    href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Roboto:wght@300;400;500;700&amp;display=swap" />
  <link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Roboto:wght@300;400;500;700&amp;display=swap"
    media="print" onload="this.media='all'" />
  <noscript>
    <link rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Roboto:wght@300;400;500;700&amp;display=swap" />
    <link rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@600&amp;family=Nunito+Sans:wght@300;400;600;700&amp;display=swap" />
  </noscript>


  <link href="/assets/css/bootstrap.min.css?ver=1.1.0" rel="stylesheet">
  <link href="/assets/css/font-awesome/css/all.min.css?ver=1.1.0" rel="stylesheet">
  <link href="/assets/css/aos.css?ver=1.1.0" rel="stylesheet">
  <link href="/assets/css/main.css?ver=1.1.0" rel="stylesheet">

  <link href="/assets/2nd/css/font-awesome/css/all.min.css?ver=1.2.0" rel="stylesheet">
  <link href="/assets/2nd/css/bootstrap.min.css?ver=1.2.0" rel="stylesheet">
  <link href="/assets/2nd/css/aos.css?ver=1.2.0" rel="stylesheet">
  <link href="/assets/2nd/css/main.css?ver=1.2.0" rel="stylesheet">
  <link href="/assets/2nd/css/mine.css?ver=1.2.0" rel="stylesheet">
  <noscript>
    <style type="text/css">
      [data-aos] {
        opacity: 1 !important;
        transform: translate(0) scale(1) !important;
      }
    </style>
  </noscript>
</head>

<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>


